import { removeArrayElement } from '@lts-web/utils/ObjectUtil';
import SitePropertyUtil from '@lts-web/utils/SitePropertyUtil';

export const COOKIE_MESSAGE_KEY = 'COOKIE_MESSAGE';
export const SEARCH_HISTORY_KEY = 'SEARCH_HISTORY';

export const getItem = (key) => {
    return localStorage.getItem(key);
};

export const setItem = (key, value) => {
    return localStorage.setItem(key, value);
};

export const hasItem = (key) => {
    return getItem(key) !== null;
};

export const getParsedItem = (key) => {
    if (!hasItem(key)) {
        return null;
    }

    return JSON.parse(getItem(key));
};

export const setStringifyItem = (key, value) => {
    setItem(key, JSON.stringify(value))
};

export const isCookieMessageVisible = () => {
    if (!hasItem(COOKIE_MESSAGE_KEY)) {
        setItem(COOKIE_MESSAGE_KEY, true);
    }

    return getParsedItem(COOKIE_MESSAGE_KEY) === true;
};

export const hideCookieMessage = () => {
    if (isCookieMessageVisible()) {
        setItem(COOKIE_MESSAGE_KEY, false);
    }
};

export const getSearchHistory = () => {
    return getParsedItem(SEARCH_HISTORY_KEY) || [];
};

export const saveSearchDataToHistory = (searchURL, formattedData) => {
    if (typeof searchURL !== 'string') {
        throw new TypeError('First argument must be of type string');
    }

    if (typeof formattedData !== 'object') {
        throw new TypeError('Second argument must be of type object');
    }

    let searchList = getSearchHistory();
    const MAX_SAVED_SEARCHES = SitePropertyUtil.getPropertyValue('GUI', 'MAX_SAVED_SEARCHES') || 10;

    searchList = searchList.filter(({ searchURL: currSearchURL }) => currSearchURL !== searchURL);

    if (searchList.length >= parseInt(MAX_SAVED_SEARCHES)) {
        searchList = searchList.slice(0, MAX_SAVED_SEARCHES - 1);
    }

    searchList.unshift({
        searchURL,
        formattedData
    });

    setStringifyItem(SEARCH_HISTORY_KEY, searchList);
};

export const removeSearchDataByIndex = (index) => {
    if (typeof index !== 'number') {
        throw new TypeError('First argument must be of type number');
    }

    const searchList = getSearchHistory();
    const filteredList = removeArrayElement(searchList, searchList[index]);

    return setStringifyItem(SEARCH_HISTORY_KEY, filteredList);
};

export const getSearchDataByIndex = (index) => {
    if (typeof index !== 'number') {
        throw new TypeError('First argument must be of type number');
    }

    return (getSearchHistory())[index] || null;
};

class LocalStorageUtil {
    static getItem = getItem;
    static setItem = setItem;
    static hasItem = hasItem;
    static getParsedItem = getParsedItem;
    static setStringifyItem = setStringifyItem;
    static isCookieMessageVisible = isCookieMessageVisible;
    static hideCookieMessage = hideCookieMessage;
    static getSearchHistory = getSearchHistory;
    static saveSearchDataToHistory = saveSearchDataToHistory;
    static removeSearchDataByIndex = removeSearchDataByIndex;
    static getSearchDataByIndex = getSearchDataByIndex;
}

export default LocalStorageUtil;